import { colors, spacing, typography } from "../../../styles/theme.js";

const styles = {
  container: {
    display: "flex",
    justifyContent: "space-between",

    alignItems: "flex-start",
    padding: `${spacing.md}px ${spacing.xl}px ${spacing.md}px ${spacing.xl}px`,

    boxShadow: "0 10px 10px -10px rgba(0, 0, 0, 0.28)",
    zIndex: 1000,
  },
  title: {
    fontSize: typography.fontSize.md,
    fontWeight: typography.fontWeight.normal,
    color: colors.textSecondary,
    margin: 0,
  },
  badge: {
    fontSize: typography.fontSize.sm,
  },
};

const SectionHeader = ({ title, badge }) => {
  return (
    <div style={styles.container}>
      <h2 style={styles.title}>{title}</h2>
      {badge && <span style={styles.badge}>{badge}</span>}
    </div>
  );
};

export default SectionHeader;
